module.exports = __webpack_public_path__ + "static/media/levels_5_3.7e447cd6.svg";